import { commonFilter } from './filter';

export default {
  pageName: 'language',
  pageId: '20009',
  pagePath: '/opinion/Stats/Language',
  common: {
    source: 2,
    typeId: 'opinion_pc_v2',
  },
  button: {
    ...commonFilter,
  },
};
